import React, { useState, useEffect } from 'react';
import { Button, Grid, TextField, Autocomplete, FormControl, useMediaQuery, useTheme } from "@mui/material";
import axios from 'axios';
import Carga from '../../../../layout/Carga';
import Swal from 'sweetalert2';
import acuerdosImg from "../../../../assets/secretaria_acuerdos.png";

interface CustomState {
    [key: string]: boolean
}
interface defaultCat {
    id: string
    Nombre: string
}

const Acuerdos = (
    { }: {}) => {

    const [loading, setLoading] = useState(false);
    const [anios, setAnios] = useState<defaultCat[]>([]);
    const [tipoPublicaciones, setTipoPublicaciones] = useState<defaultCat[]>([]);
    const [tipoPublicacionId, setTipoPublicacionId] = useState("");
    const [acuerdos, setAcuerdos] = useState([]);
    
    const handleDescarga = (id: string) => {
        const url = `${process.env.REACT_APP_APPLICATION_ENDPOINT}/documentos/descarga/pf_acuerdos/${id}`;
        window.open(url, '_blank');
    };
    const [anio, setAnio] = useState(new Date().getFullYear().toString());
    const handleChangeAnio = (event: any, newValue: any) => {
        const selectedId = newValue?.id ? newValue?.id : "";
        const selectedItem = anios.find(
            (item) => item.id === selectedId
        );
        if (selectedItem) {
            setAnio(selectedItem.id);
        } else {
            setAnio(new Date().getFullYear().toString());
        }
    };
    const handleChangeType = (event: any, newValue: any) => {
        const selectedId = newValue?.id ? newValue?.id : "";
        const selectedItem = tipoPublicaciones.find(
            (item) => item.id === selectedId
        );
        if (selectedItem) {
            setTipoPublicacionId(selectedItem.id);
        } else {
            setTipoPublicacionId("");
        }
    };

    const obtenerAcuerdos = async () => {
        try {
            setLoading(true)
            const response = await axios({
                method: "get",
                url: process.env.REACT_APP_APPLICATION_ENDPOINT + "/public/consulta/pf/acuerdos",
                params: {
                    anio: anio,
                    tipoPublicacionId: tipoPublicacionId
                },
                headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*"
                }
            });
            const data = response.data.data;
            setAcuerdos(data);
            setLoading(false)
        } catch (error: any) {
            const mensaje =
                error?.response?.data?.error ||
                error?.response?.data?.message ||
                error?.message ||
                'Ocurrió un error inesperado';

            Swal.fire({
                icon: 'error',
                title: 'Error en la consulta',
                text: mensaje,
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#15212f",
            });
        } finally {
            setLoading(false);
        }
    };

    const getAnios = async () => {
        try {
            setLoading(true)
            const response = await axios.get(process.env.REACT_APP_APPLICATION_ENDPOINT + "/public/consulta/pf/acuerdos/anios");
            const data = response.data;
            const formattedAnios = data.map((item: { anio: number }) => ({
                Nombre: item.anio.toString(),
                id: item.anio.toString(),
            }));
            setAnios(formattedAnios);
            setLoading(false)
        } catch (error: any) {
            setLoading(false)
            const mensaje =
                error?.response?.data?.error ||
                error?.response?.data?.message ||
                error?.message ||
                'Ocurrió un error inesperado';

            Swal.fire({
                icon: 'error',
                title: 'Error en la consulta',
                text: mensaje,
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#15212f",
            });
        }
    };

    const getTipos = async () => {
        try {
            setLoading(true)
            const response = await axios.get(process.env.REACT_APP_APPLICATION_ENDPOINT + "/public/consulta/tipopublicacion");
            const data = response.data.data;
            const formattedTipos = data.map((item: { id: string, nombre: string }) => ({
                Nombre: item.nombre,
                id: item.id,
            }));
            setTipoPublicaciones(formattedTipos);
            setLoading(false)
        } catch (error: any) {
            setLoading(false)
            const mensaje =
                error?.response?.data?.error ||
                error?.response?.data?.message ||
                error?.message ||
                'Ocurrió un error inesperado';

            Swal.fire({
                icon: 'error',
                title: 'Error en la consulta',
                text: mensaje,
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#15212f",
            });
        }
    };

    useEffect(() => {
        const cargarDatosSecuencialmente = async () => {
            try {
                await obtenerAcuerdos();
                await getAnios();
                await getTipos();
            } catch (error: any) {
                const mensaje =
                    error?.response?.data?.error ||
                    error?.response?.data?.message ||
                    error?.message ||
                    'Ocurrió un error inesperado';

                Swal.fire({
                    icon: 'error',
                    title: 'Error en la consulta',
                    text: mensaje,
                    confirmButtonText: "Aceptar",
                    confirmButtonColor: "#15212f",
                });
            }
        };

        cargarDatosSecuencialmente();
    }, []);



    return (
        <>
            <Carga isLoading={loading} />

            <Grid container spacing={2}>
                {/* Filtros */}
                <Grid item xs={12} md={4} mt={2}>
                    <FormControl fullWidth sx={{ bgColor: "#fff" }}>
                        <Autocomplete
                            limitTags={2}
                            id="anios"
                            options={anios}
                            getOptionLabel={(option) => option.Nombre}
                            value={anios.find((m) => m.id == anio) || null}
                            onChange={handleChangeAnio}
                            renderInput={(params) => (
                                <TextField {...params} label="Año" placeholder="Año" />
                            )}
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={12} md={4} mt={2}>
                    <FormControl fullWidth sx={{ bgColor: "#fff" }}>
                        <Autocomplete
                            limitTags={2}
                            id="meses"
                            options={tipoPublicaciones}
                            getOptionLabel={(option) => option.Nombre}
                            value={
                                tipoPublicaciones.find((m) => m.id == tipoPublicacionId) || null
                            }
                            onChange={handleChangeType}
                            renderInput={(params) => (
                                <TextField {...params} label="Tipo de Publicación" placeholder="Tipo" />
                            )}
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={12} md={2} padding={2} sx={{ display: 'flex', alignItems: 'center' }}>
                    <Button size="large" variant="contained" onClick={obtenerAcuerdos} fullWidth>
                        Filtrar
                    </Button>
                </Grid>

                {/* Lista de documentos en UNA columna */}
                <Grid container spacing={2} sx={{marginTop:"2rem"}}>
                    {acuerdos.map((acuerdo: any) => (
                        <Grid
                            key={acuerdo.id}
                            item
                            xs={12}
                            sm={6}
                            md={2.4}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                cursor: 'pointer',
                                textAlign: 'center',
                            }}
                            onClick={() => handleDescarga(acuerdo.id)}
                        >
                            <img
                                src={acuerdosImg}
                                alt={acuerdo.titulo}
                                style={{
                                    width: '100%',
                                    maxWidth: '120px',
                                    height: 'auto',
                                    objectFit: 'cover',
                                    borderRadius: 8,
                                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)", // sombra elegante
                                }}
                            />
                            <span
                                style={{
                                    marginTop: '8px',
                                    wordBreak: 'break-word',
                                    maxWidth: '180px',
                                }}
                            >
                                {acuerdo.titulo}
                            </span>
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </>
    );

};

export { Acuerdos };